import { createSlice } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';

import {
  GetQuestionsApi,
  GetQuestionsApi_extrareducer,
  PrePopulatePanApi,
  PrePopulatePanApi_extrareducer,
  QuestionDecisionApi,
  QuestionDecisionApi_extrareducer,
} from './api/pre-pan-api-calls/index';

const initialState = {
  blockId: 0,
  onScreenComp: ['WELCOME_SCR'],
  prepanDetailsType: null,
  isPrepanPreFilled: false,
  formViewSubmission: false,
  prevBlockId: null,
  prevScreens: [],
  getQuestionsApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  prePopulatePanApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  questionDecisionApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  custJourneyAns: [
    {
      answer: {
        firstName: null,
        lastName: null,
      },
      questionId: 1,
    },
    {
      answer: {
        dob: null,
      },
      questionId: 2,
    },
    {
      answer: {
        empType: null,
      },
      questionId: 3,
    },
    {
      answer: {
        pan: null,
      },
      questionId: 4,
    },
  ],
  isInitialRender: {
    welcomeScreen: true,
    nameScreen: true,
    dobScreen: true,
    empTypeScreen: true,
    panScreen: true,
    loadingScreen: true, // for questiondecision api call
    prePopulatePanLoandingScreen: true,
    softRejectionLoader: true,
  },
  isContinuedToPostpan: false,
  submitBtnClickedCount: 0,
  showPrePopulatePanLoader: true,
  isPrePanSoftRejected: false,
  preventScreenUpdate: false,
  panUpdatedOnDrawer: false,
  callQuesDecisionForSoftRejection: false,
  softRejectionFlag: false, // To store the data from getQuestions API
  // NOTE:If the user is softRejected we show the confirm your details screen which has to persisted if the user goes to diff screen and across differnt sessions as well
};

export const prePanJourneySlice = createSlice({
  name: 'prePanJourney',
  initialState,
  reducers: {
    updateBlockId: (state, action) => {
      const newBlockId = action.payload;
      state.blockId = newBlockId;
    },
    updateOnScreenComp: (state, action) => {
      state.onScreenComp.length = 0; // empty the array
      state.onScreenComp = [...action.payload];
    },
    updatePrepanDetailsType: (state, action) => {
      state.prepanDetailsType = action.payload;
    },
    updatePrepanPreFilled: (state, action) => {
      state.isPrepanPreFilled = action.payload;
    },
    updateFormViewSubmission: (state, action) => {
      state.formViewSubmission = action.payload;
    },
    updatePrevBlockId: (state, action) => {
      const prevBlockId = action.payload;
      state.prevBlockId = prevBlockId;
    },
    updatePrevScreens: (state, action) => {
      state.prevScreens.length = 0;
      state.prevScreens = [...action.payload];
    },
    // TODO: Payload should be a obj eg:{questionId:1,anwser:{dob:"30/05/1997"}}
    updateUserInputs: (state, action) => {
      const { questionId, answer } = action.payload;
      const questionIndex = state.custJourneyAns.findIndex(
        (question) => question.questionId === questionId
      );
      state.custJourneyAns[questionIndex].answer = answer;
    },
    updateInitialRender: (state, action) => {
      state.isInitialRender[action.payload] = false;
    },
    updateIsContinuedToPostpan: (state, action) => {
      console.log('updateIsContinuedToPostpan', action.payload);
      state.isContinuedToPostpan = action.payload;
    },
    updateSubmitBtnClickedCount: (state, action) => {
      state.submitBtnClickedCount = action.payload;
    },
    updateShowPrePopulatePanLoader: (state) => {
      state.showPrePopulatePanLoader = false;
    },
    updatePrePanSoftRejected: (state, action) => {
      state.isPrePanSoftRejected = action.payload;
    },
    setPanUpdateOnDrawer: (state, action) => {
      state.panUpdatedOnDrawer = action.payload;
    },
    resetQuestionDecisionApiState: (state) => {
      state.questionDecisionApiState = {
        response: {},
        isLoading: false,
        isError: false,
        isSuccess: false,
      };
    },
    updatePreventScreenUpdate: (state) => {
      state.preventScreenUpdate = true;
    },
    updateSoftRejectionFlag: (state, action) => {
      state.softRejectionFlag = action.payload;
    },
    updateCallQuesDecisionForSoftRejection: (state, action) => {
      state.callQuesDecisionForSoftRejection = action.payload;
    },
    clearState: (state) => {
      // Note that is left intentionally empty.
      // Clearing redux state and localForage happens in rootReducer.
    },
  },
  extraReducers: {
    ...GetQuestionsApi_extrareducer,
    ...PrePopulatePanApi_extrareducer,
    ...QuestionDecisionApi_extrareducer,
  },
});

export function usePrePanStore() {
  const blockId = useSelector((state) => state.prePanJourney.blockId);
  const onScreenComp = useSelector((state) => state.prePanJourney.onScreenComp);
  const prevBlockId = useSelector((state) => state.prePanJourney.prevBlockId);
  const prepanDetailsType = useSelector(
    (state) => state.prePanJourney.prepanDetailsType
  );
  const isPrepanPreFilled = useSelector(
    (state) => state.prePanJourney.isPrepanPreFilled
  );
  const formViewSubmission = useSelector(
    (state) => state.prePanJourney.formViewSubmission
  );
  const prevScreens = useSelector((state) => state.prePanJourney.prevScreens);
  const userInputs = useSelector((state) => state.prePanJourney.custJourneyAns);
  const isInitialRender = useSelector(
    (state) => state.prePanJourney.isInitialRender
  );
  const questionDecisionPrePanResp = useSelector(
    (state) => state.prePanJourney.questionDecisionPrePanResp
  );
  const isContinuedToPostpan = useSelector(
    (state) => state.prePanJourney.isContinuedToPostpan
  );
  const submitBtnClickedCount = useSelector(
    (state) => state.prePanJourney.submitBtnClickedCount
  );
  const panUpdatedOnDrawer = useSelector(
    (state) => state.prePanJourney.panUpdatedOnDrawer
  );
  // Api State
  const getQuestionsApiState = useSelector(
    (state) => state.prePanJourney.getQuestionsApiState
  );
  const prePopulatePanApiState = useSelector(
    (state) => state.prePanJourney.prePopulatePanApiState
  );
  const questionDecisionApiState = useSelector(
    (state) => state.prePanJourney.questionDecisionApiState
  );
  const showPrePopulatePanLoader = useSelector(
    (state) => state.prePanJourney.showPrePopulatePanLoader
  );
  const isPrePanSoftRejected = useSelector(
    (state) => state.prePanJourney.isPrePanSoftRejected
  );
  const preventScreenUpdate = useSelector(
    (state) => state.prePanJourney.preventScreenUpdate
  );
  const callQuesDecisionForSoftRejection = useSelector(
    (state) => state.prePanJourney.callQuesDecisionForSoftRejection
  );
  const softRejectionFlag = useSelector(
    (state) => state.prePanJourney.softRejectionFlag
  );
  const dispatch = useDispatch();
  return {
    // state values
    blockId,
    onScreenComp,
    prevBlockId,
    prepanDetailsType,
    isPrepanPreFilled,
    formViewSubmission,
    prevScreens,
    getQuestionsApiState,
    prePopulatePanApiState,
    questionDecisionApiState,
    userInputs,
    isInitialRender,
    questionDecisionPrePanResp,
    isContinuedToPostpan,
    submitBtnClickedCount,
    showPrePopulatePanLoader,
    isPrePanSoftRejected,
    preventScreenUpdate,
    panUpdatedOnDrawer,
    callQuesDecisionForSoftRejection,
    softRejectionFlag,
    // reducers
    updateBlockId: (blockId) => dispatch(updateBlockId(blockId)),
    updateOnScreenComp: (screens) => dispatch(updateOnScreenComp(screens)),
    updatePrevBlockId: (prevBlockId) =>
      dispatch(updatePrevBlockId(prevBlockId)),
    updatePrevScreens: (screens) => dispatch(updatePrevScreens(screens)),
    updateUserInputs: (userInput) => dispatch(updateUserInputs(userInput)),
    updatePrepanDetailsType: (payload) =>
      dispatch(updatePrepanDetailsType(payload)),
    updatePrepanPreFilled: (payload) =>
      dispatch(updatePrepanPreFilled(payload)),
    updateFormViewSubmission: (payload) =>
      dispatch(updateFormViewSubmission(payload)),
    updateInitialRender: (screenName) =>
      dispatch(updateInitialRender(screenName)),
    updateIsContinuedToPostpan: (isMappingToPostpan) =>
      dispatch(updateIsContinuedToPostpan(isMappingToPostpan)),
    updateSubmitBtnClickedCount: (payload) =>
      dispatch(updateSubmitBtnClickedCount(payload)),
    updateShowPrePopulatePanLoader: () =>
      dispatch(updateShowPrePopulatePanLoader()),
    updateCallQuesDecisionForSoftRejection: (payload) =>
      dispatch(updateCallQuesDecisionForSoftRejection(payload)),
    resetQuestionDecisionApiState: () =>
      dispatch(resetQuestionDecisionApiState()),
    updatePrePanSoftRejected: () => dispatch(updatePrePanSoftRejected()),
    updatePreventScreenUpdate: () => dispatch(updatePreventScreenUpdate()),
    setPanUpdateOnDrawer: (payload) => dispatch(setPanUpdateOnDrawer(payload)),
    updateSoftRejectionFlag: (payload) =>
      dispatch(updateSoftRejectionFlag(payload)),
    // api_calls
    GetQuestionsApi: (payload) => dispatch(GetQuestionsApi(payload)),
    PrePopulatePanApi: (payload) => dispatch(PrePopulatePanApi(payload)),
    QuestionDecisionApi: (payload) => dispatch(QuestionDecisionApi(payload)),
  };
}

export const {
  updateBlockId,
  updateOnScreenComp,
  updatePrepanDetailsType,
  updatePrepanPreFilled,
  updateFormViewSubmission,
  updatePrevBlockId,
  updatePrevScreens,
  updateUserInputs,
  updateInitialRender,
  updateIsContinuedToPostpan,
  updateSubmitBtnClickedCount,
  updateShowPrePopulatePanLoader,
  updatePrePanSoftRejected,
  resetQuestionDecisionApiState,
  updatePreventScreenUpdate,
  setPanUpdateOnDrawer,
  updateCallQuesDecisionForSoftRejection,
  updateSoftRejectionFlag,
  clearState,
} = prePanJourneySlice.actions;

export default prePanJourneySlice.reducer;
